import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
export const useEventListTotalCount = (institutionId, t0) => {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  const {
    entry
  } = useWebviewTypeEntry();
  let t3;
  if ($[2] !== entry || $[3] !== institutionId) {
    t3 = UnauthQueryOptions["get:/wello/v2/allows/home/institution-event"]({
      query: {
        excludeEndedYN: true,
        institutionId,
        page: 1,
        size: 1,
        entry
      }
    });
    $[2] = entry;
    $[3] = institutionId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== enabled || $[6] !== t3) {
    t4 = {
      ...t3,
      select: _temp,
      enabled
    };
    $[5] = enabled;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return useQuery(t4);
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context?.totalCount;
}